import { fetchApi } from "../../../../lib/fetchApi";
import { SentimentAnalysisApiItem, SentimentFormDto } from "../types";

export const createSentiment = async (body: SentimentFormDto): Promise<void> => {
    await fetchApi.post("/sentiment/create", body);
};

export const getSentiments = async (): Promise<SentimentAnalysisApiItem[]> => {
    const response = await fetchApi.get("/sentiment") as SentimentAnalysisApiItem[];
    return response;
};

export const deleteSentiment = async (id: number): Promise<void> => {
    await fetchApi.delete(`/sentiment/${id}`);
};

export const getSentimentById = async (id: number): Promise<SentimentAnalysisApiItem> => {
    const response = await fetchApi.get(`/sentiment/${id}`) as SentimentAnalysisApiItem;
    return response;
};

export const updateSentiment = async (id: number, body: SentimentFormDto): Promise<void> => {
    await fetchApi.put(`/sentiment/${id}`, body);
};

